import React, { Fragment } from 'react';
import { InfinitySpin } from 'react-loader-spinner';

const Spinner = () => (
  <Fragment>
    <InfinitySpin
      visible={true}
      width="200"
      color="#ff7b29"
      ariaLabel="infinity-spin-loading"
    />
  </Fragment>
);

export default Spinner;
